import { CounterAnimated } from "./CounterAnimated";
import { motion } from "framer-motion";

const KPIS = [
  {
    value: 300,
    suffix: "+",
    label: "Références professionnelles",
    sub: "13 gammes complètes",
  },
  {
    value: 24,
    suffix: "h",
    label: "Livraison Île-de-France",
    sub: "Sans rupture",
  },
  {
    value: 15,
    suffix: "+",
    label: "Ans de trajectoire",
    sub: "Partenaire B2B depuis 2009",
  },
];

/**
 * KPIsCounters — 3 business KPIs with counter-on-scroll animation.
 */
export const KPIsCounters = () => (
  <section
    data-testid="kpis-counters"
    className="relative bg-fd-elevated border-t border-fd-border py-24 lg:py-32 px-6 md:px-10 lg:px-14"
  >
    <div className="max-w-[1400px] mx-auto">
      <div className="mono-label-gold mb-10 flex items-center gap-3">
        <span className="w-8 h-px bg-fd-gold"></span>
        <span>Performance / Chiffres</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16">
        {KPIS.map((k, i) => (
          <motion.div
            key={k.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="border-l-2 border-fd-gold pl-6"
            data-testid={`kpi-${i}`}
          >
            <CounterAnimated
              value={k.value}
              duration={2200}
              suffix={k.suffix}
              className="display-xl text-6xl md:text-7xl lg:text-8xl text-gradient-gold"
            />
            <p className="mt-4 font-display text-lg lg:text-xl uppercase tracking-tight">{k.label}</p>
            <p className="mt-1 mono-label">{k.sub}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
